import { Outlet, Link } from "react-router-dom";
import { AdminSidebar } from "./AdminSidebar";

export function AdminLayout() {
  return (
    <div className="min-h-screen bg-gray-950 flex">
      <AdminSidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <header className="h-14 border-b border-gray-800 flex items-center px-6 bg-gray-900/50">
          <Link
            to="/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-400 hover:text-cyan-400 transition-colors"
          >
            <i className="ri-external-link-line mr-1" />
            Voir le site
          </Link>
        </header>
        <main className="flex-1 p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
